import {v4 as uuid} from 'uuid';

export const getDeviceId = () => {
  let deviceId = window.localStorage.getItem('did') || '';
  if (deviceId) return deviceId;
  deviceId = uuid();
  window.localStorage.setItem('did', deviceId);
  return deviceId;
};
